export const SHOW_COUNTRY = 'SHOW_COUNTRY'

export const SHOW_BOOKKEEPER = 'SHOW_BOOKKEEPER'

export const SHOW_PAYROLL_POLICY = 'SHOW_PAYROLL_POLICY'
